export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_02.bf909677.jpg";